import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonService {


  razaoSocial: string = 'Carregando...'
  telefono: string = ''
  email: string = ''
  imagePath: string = ''

  @Output() razaoSocialChange: EventEmitter<string> = new EventEmitter();
  @Output() telefonoChange: EventEmitter<string> = new EventEmitter();
  @Output() emailChange: EventEmitter<string> = new EventEmitter();
  @Output() imagePathChange: EventEmitter<string> = new EventEmitter();

  changeRazonSocial(novaRazaoSocial){
    this.razaoSocial = novaRazaoSocial
    this.razaoSocialChange.emit(this.razaoSocial);
  }
  changeTelefono(novoTelefono){
    this.telefono = novoTelefono
    this.telefonoChange.emit(this.telefono);
  }
  changeEmail(novoEmail){
    this.email = novoEmail
    this.emailChange.emit(this.email);
  }
  changeImagePath(novaImagePath){
    this.imagePath = novaImagePath
    this.imagePathChange.emit(this.imagePath);
  }
}
